
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Select from "./Select.vue";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class CommoditySelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  localCommodities: Array<any> = [];

  @Prop({ default: null })
  public billTo: string;

  @Prop({ default: () => null })
  public commodities: any[];

  @Prop({ default: false })
  public preload: true;

  async created() {
    if (this.preload) {
      let payload = {
        code: "",
        billTo: this.billTo
      };
      let results = await systemModule.searchCommoditiesByCode(payload);
      this.$data.localCommodities = results.map(x => ({ label: x.code, value: x.code }));
    }
  }

  @Watch("billTo")
  async billToChanged() {
    if (this.preload) {
      let payload = {
        code: "",
        billTo: this.billTo
      };
      let results = await systemModule.searchCommoditiesByCode(payload);
      this.$data.localCommodities = results.map(x => ({ label: x.code, value: x.code }));
    }
  }

  async search(value, loading) {
    if (this.commodities) return;

    loading(true);
    let payload = {
      code: value,
      billTo: this.billTo
    };
    try {
      let results = await systemModule.searchCommoditiesByCode(payload);

      this.$data.localCommodities = results.map(x => ({ label: x.code, value: x.code }));
    } finally {
      loading(false);
    }
  }

  get items() {
    if (this.commodities) return this.commodities;
    return this.$data.localCommodities;
  }
}
